import { decodeJwtPayload } from '@/auth/core/decodeJwtPayload';

/**
 * Whether the bearer JWT is past its `exp` claim (UX hint only; server still validates).
 * @param {string} bearerToken
 * @param {number} [nowMs]
 * @returns {boolean}
 */
export function isBearerExpired(bearerToken: string, nowMs = Date.now()): boolean {
  const payload = decodeJwtPayload(bearerToken);
  const exp = payload?.exp;

  if (typeof exp !== 'number' || !Number.isFinite(exp)) {
    return true;
  }

  return exp * 1000 <= nowMs;
}
